import React, { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Card, Button } from 'antd';

const AdminPageEditor = ({ initialValue = '', onSave, isSaving }) => {
  const editorRef = useRef(null);

  const handleSave = () => {
    if (editorRef.current) {
      const content = editorRef.current.getContent();
      onSave(content); // Pass the HTML string up to the parent
    }
  };

  return (
    <Card title="Start Page Editor" bordered={false}>
      <Editor
        apiKey="5i62g5jk8xf0jarv4fua87ffqqzn32nin4h0m47yu05ydxvs" // Your TinyMCE API key
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={initialValue}
        init={{
          height: 600,
          menubar: 'file edit view insert format tools table help',
          plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor',
            'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'media',
            'table', 'help', 'wordcount'
          ],
          toolbar:
            'undo redo | blocks | bold italic forecolor backcolor | ' +
            'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | link image | code | help',
          block_formats: 'Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3',
          content_style: 'a { font-family: Quicksand,sans-serif; font-size:14px }, ',
        }}
      />
      <Button
        type="primary"
        onClick={handleSave}
        loading={isSaving}
        style={{ marginTop: 16 }}
      >
        Save Page Content
      </Button>
    </Card>
  );
};

export default AdminPageEditor;